/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Staff_Nav_DomainsInputs */

const id_staff_nav_domains = /** @type {(inputs: Staff_Nav_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domain`)
};

const en_staff_nav_domains = /** @type {(inputs: Staff_Nav_DomainsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domains`)
};

/**
* | output |
* | --- |
* | "Domains" |
*
* @param {Staff_Nav_DomainsInputs} inputs
* @param {{ locale?: "id" | "en" }} options
* @returns {LocalizedString}
*/
export const staff_nav_domains = /** @type {((inputs?: Staff_Nav_DomainsInputs, options?: { locale?: "id" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Staff_Nav_DomainsInputs, { locale?: "id" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_staff_nav_domains(inputs)
	return id_staff_nav_domains(inputs)
});